"use client";

const extractText = (richText) => {
  if (!richText) return "";
  if (typeof richText === "string") return richText.trim();

  if (Array.isArray(richText)) {
    return richText
      .map((block) => extractText(block))
      .join(" ")
      .trim();
  }

  if (richText.children && Array.isArray(richText.children)) {
    return richText.children
      .map((child) => {
        if (child.type === "text" && child.text) return child.text;
        if (child.type === "link" && child.children?.[0]?.text) {
          return child.children[0].text;
        }
        return extractText(child);
      })
      .join("")
      .trim();
  }
  return "";
};

const ProgramCard = ({ program }) => {
  if (!program) return null;

  const courseName = extractText(program.coursename);
  const courseDetails = extractText(program.coursedetails);
  const courseimage =
    program.courseimage?.data?.[0]?.attributes ||
    program.courseimage?.attributes ||
    program.courseimage;

  const courseImgUrl =
    courseimage?.formats?.medium?.url ||
    courseimage?.formats?.small?.url ||
    courseimage?.formats?.large?.url ||
    courseimage?.url ||
    "";
  const rawLines = Array.isArray(program.otherdetails)
    ? program.otherdetails.map((block) => extractText([block])).filter(Boolean)
    : Array.isArray(program.otherdetails?.children)
      ? [extractText(program.otherdetails)]
      : [];

  const lines = rawLines.map((line) => {
    const [label, ...rest] = line.split(":");
    return {
      label: label?.trim() || "",
      value: rest.join(":").trim(),
    };
  });

  return (
    <div className="flex flex-col bg-white border border-gray-200 shadow-sm h-full w-full">
      {courseImgUrl && (
        <div className="w-full">
          <img
            src={courseImgUrl}
            alt={courseName || "Program image"}
            className="w-full h-70 object-cover"
          />
        </div>
      )}
      <div className="px-8 py-7 flex flex-col gap-5 flex-1">
        <div>
          <h3
            style={{ fontFamily: "saans-bold" }}
            className="text-xl text-black"
          >
            {courseName}
          </h3>
          {courseDetails && (
            <p
              style={{ fontFamily: "saans-regular" }}
              className="mt-2 text-sm leading-relaxed text-gray-700"
            >
              {courseDetails}
            </p>
          )}
        </div>
        <div
          style={{ fontFamily: "saans-regular" }}
          className="space-y-1 text-sm text-black flex-1"
        >
          {lines.map(({ label, value }, idx) => (
            <p key={idx}>
              {label && <span className="font-bold">{label}:</span>}
              {value && <span className="font-normal"> {value}</span>}
            </p>
          ))}
        </div>
        <div className="mt-4 flex flex-wrap gap-4">
          {/* <button
            style={{ fontFamily: "saans-regular" }}
            className="px-5 py-2 text-sm border border-gray-900 text-gray-900 hover:bg-gray-100 transition"
          >
            Download Brochure
          </button> */}
          {program?.courseUrl ? (
            <a
              href={program.courseUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Explore ${courseName}`}
              className="px-5 py-2 text-sm bg-[#F5A623] text-black hover:bg-[#e2961f] transition inline-block"
              style={{ fontFamily: "saans-bold" }}
            >
              Explore Programme
            </a>
          ) : (
            <button
              style={{ fontFamily: "saans-bold" }}
              className="px-5 py-2 text-sm bg-[#F5A623] text-black hover:bg-[#e2961f] transition"
            >
              Explore Programme
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
